import React, { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ClaimsCheckForm } from "@covertree/new-business-forms";
import { checkAndAddPriorClaim } from "@covertree/new-business-redux";

import { useAppDispatch } from "@redux/hooks";
import { NewPolicyRoutes, navigateToPolicyStep } from "@routing/paths";
import {
  ClaimsCheck,
  transformToFormerAddress,
} from "@covertree/new-business-past-claims";

export default function ClaimsCheckStep() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClaimsCheck = useCallback<SubmitHandler<ClaimsCheckForm>>(
    async (formData) => {
      const formerAddress = transformToFormerAddress(formData);
      if (!formerAddress) return;

      try {
        await dispatch(checkAndAddPriorClaim({ formerAddress })).unwrap();
        navigateToPolicyStep(
          navigate,
          NewPolicyRoutes.CLAIMS_LIST,
          NewPolicyRoutes.CLAIMS_CHECK
        );
      } catch {
        navigateToPolicyStep(
          navigate,
          NewPolicyRoutes.ERROR,
          NewPolicyRoutes.CLAIMS_CHECK
        );
      }
    },
    [dispatch, navigate]
  );

  return (
    <Stack spacing={2}>
      <Typography>Let&#39;s check on past claims.</Typography>
      <ClaimsCheck handleClaimsCheck={handleClaimsCheck} />
    </Stack>
  );
}
